import React from 'react';
import { useTranslation } from 'react-i18next';

const optionsConfig = [
  { value: 'active', labelKey: 'entityStatus.active' },
  { value: 'passive', labelKey: 'entityStatus.passive' },
  { value: 'all', labelKey: 'entityStatus.all' },
];

export const EntityStatusFilter = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="inline-flex items-center bg-gray-100 rounded-md p-0.5">
      {optionsConfig.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={`px-3 py-1.5 text-sm rounded font-medium transition-colors ${
            value === opt.value
              ? 'bg-primary-600 text-white'
              : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          {t(opt.labelKey)}
        </button>
      ))}
    </div>
  );
};